import logoUrl from "../images/logo.png";

function Header() {
  return (
    <div className="main-header">
      <img src={logoUrl} className="logo" />

      <p className="lead-text">
        Ce site a pour vocation de centraliser toutes les informations au sujet
        de la situation à Mayotte. Tous les liens de la communauté sont
        disponibles ici :{" "}
        <a
          href="https://linktr.ee/helpmayotte"
          target="_blank"
          rel="noopener noreferrer"
          className="info-link"
        >
          https://linktr.ee/helpmayotte
        </a>
      </p>
    </div>
  );
}

export default Header;
